import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm$vueFlux$images, _vm$vueFlux$images2, _vm$vueFlux$images3;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("return", {
    ref: "return",
    attrs: {
      label: "Regions",
      routeName: _vm.loggedUserData.userGroup === "ADMIN" ? "adminRegionList" : "userRegionList",
      query: {
        tab: _vm.regionType,
        idRegion: _vm.region.id
      }
    }
  }), _c("div", {
    staticClass: "container-centered small"
  }, [_c("h3", {
    attrs: {
      id: "region-title"
    }
  }, [_vm._v(_vm._s(_vm.region.name))]), _c("div", {
    attrs: {
      id: "region-description"
    },
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.region.description))
    }
  }), _vm.canManageRegions ? _c("div", {
    staticClass: "mt-2 mb-3 flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openEditModal();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-pen mr-2",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Edit ")], 1)], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "region-content"
    }
  }, [!_vm.mapFailedLoading ? _c("div", [_vm.region.regionSubs.length ? _c("div", {
    attrs: {
      id: "container-map"
    }
  }, [_c("div", [_c("Map", {
    attrs: {
      types: ["region", "poi"],
      country: _vm.region.country.iso_2,
      address: _vm.regionAddress
    },
    on: {
      mapFailedLoading: function mapFailedLoading($event) {
        _vm.mapFailedLoading = true;
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _c("div", {
    attrs: {
      id: "region-img-container"
    }
  }, [_c("div", {
    attrs: {
      id: "region-img"
    }
  }, [!_vm.defaultImage ? _c("vue-flux", {
    ref: "slider",
    attrs: {
      options: _vm.vueFlux.options,
      images: _vm.vueFlux.images,
      transitions: ((_vm$vueFlux$images = _vm.vueFlux.images) === null || _vm$vueFlux$images === void 0 ? void 0 : _vm$vueFlux$images.length) > 1 ? _vm.vueFlux.transitions : []
    },
    scopedSlots: _vm._u([((_vm$vueFlux$images2 = _vm.vueFlux.images) === null || _vm$vueFlux$images2 === void 0 ? void 0 : _vm$vueFlux$images2.length) > 1 ? {
      key: "controls",
      fn: function fn() {
        return [_c("flux-controls")];
      },
      proxy: true
    } : null, ((_vm$vueFlux$images3 = _vm.vueFlux.images) === null || _vm$vueFlux$images3 === void 0 ? void 0 : _vm$vueFlux$images3.length) > 1 ? {
      key: "pagination",
      fn: function fn() {
        return [_c("flux-pagination")];
      },
      proxy: true
    } : null], null, true)
  }) : _c("img", {
    attrs: {
      src: require("@/assets/images/_temp/wine-detail-gallery.jpg"),
      alt: ""
    }
  })], 1)])]), _c("div", {
    attrs: {
      id: "subregions-content"
    }
  }, [_vm.region.regionSubs.length ? _c("div", {
    attrs: {
      id: "subregions-list"
    }
  }, _vm._l(_vm.regionWithSubsSorted.regionSubs, function (subRegion) {
    var _subRegion$producers, _subRegion$image, _subRegion$image2, _subRegion$producers2;
    return _c("div", {
      key: subRegion.id,
      staticClass: "subregion-container",
      class: [((_subRegion$producers = subRegion.producers) === null || _subRegion$producers === void 0 ? void 0 : _subRegion$producers.length) < 1 ? "disabled" : null],
      on: {
        click: function click($event) {
          return _vm.visibleSubRegion(subRegion.id);
        }
      }
    }, [_c("div", {
      staticClass: "subregion"
    }, [_c("div", {
      staticClass: "subregion-img-container"
    }, [_c("div", {
      staticClass: "subregion-img"
    }, [((_subRegion$image = subRegion.image) === null || _subRegion$image === void 0 || (_subRegion$image = _subRegion$image.thbAbsoluteUri) === null || _subRegion$image === void 0 ? void 0 : _subRegion$image.length) > 0 ? _c("img", {
      attrs: {
        src: subRegion.image.thbAbsoluteUri,
        alt: ""
      }
    }) : ((_subRegion$image2 = subRegion.image) === null || _subRegion$image2 === void 0 || (_subRegion$image2 = _subRegion$image2.absoluteUri) === null || _subRegion$image2 === void 0 ? void 0 : _subRegion$image2.length) > 0 ? _c("img", {
      attrs: {
        src: subRegion.image.absoluteUri,
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: require("@/assets/images/appellation.jpg"),
        alt: ""
      }
    })]), ((_subRegion$producers2 = subRegion.producers) === null || _subRegion$producers2 === void 0 ? void 0 : _subRegion$producers2.length) === 0 ? _c("div", {
      staticClass: "subregion-disabled-filigree"
    }, [_vm._v(" Curated selection on demand ")]) : _vm._e(), _c("div", {
      staticClass: "subregion-label"
    }, [_c("label", [_vm._v(_vm._s(subRegion.name))])])])])]);
  }), 0) : _vm._e(), _c("div", {
    attrs: {
      id: "subregion-details"
    }
  }, [_vm.region.regionSubs.length ? _c("div", [_vm._l(_vm.regionWithSubsSorted.regionSubs, function (subRegion) {
    return _c("div", {
      key: subRegion.id + "title"
    }, [_vm.activeSubRegion == subRegion.id ? _c("div", [_c("h4", {
      staticClass: "subregion-title"
    }, [_vm._v(_vm._s(subRegion.name))])]) : _vm._e()]);
  }), _vm._l(_vm.regionWithSubsSorted.regionSubs, function (subRegion) {
    return _c("div", {
      key: subRegion.id
    }, [_vm.activeSubRegion == subRegion.id ? _c("div", {
      staticClass: "subregion-wineries-list"
    }, _vm._l(subRegion.producers, function (winery) {
      return _c("div", {
        key: winery.producerId,
        staticClass: "winery-container",
        class: [winery.nbProducts == 0 ? "disabled" : null]
      }, [_c("router-link", {
        staticClass: "router-link --no-hover-underlined",
        attrs: {
          to: winery.nbProducts > 0 ? _vm.selectWinery(winery.producerId) : "#"
        }
      }, [_c("div", {
        staticClass: "winery"
      }, [_c("div", {
        staticClass: "winery-img-container"
      }, [_c("div", {
        staticClass: "winery-img"
      }, [!_vm.wineryImagesBroken.includes(winery.producerId) && winery.imageThumbnail != null && winery.imageThumbnail.length > 0 ? _c("img", {
        attrs: {
          src: winery.imageThumbnail,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.wineryImagesBroken.push(winery.producerId);
          }
        }
      }) : !_vm.wineryImagesBroken.includes(winery.producerId) && winery.image != null && winery.image.length > 0 ? _c("img", {
        attrs: {
          src: winery.image,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.wineryImagesBroken.push(winery.producerId);
          }
        }
      }) : _c("img", {
        attrs: {
          src: require("@/assets/images/winery.jpg"),
          alt: ""
        }
      })]), winery.nbProducts === 0 ? _c("div", {
        staticClass: "winery-disabled-filigree"
      }, [_vm._v(" Curated selection on demand ")]) : _vm._e(), _c("div", {
        staticClass: "winery-label"
      }, [_vm._v(_vm._s(winery.name))])])])])], 1);
    }), 0) : _vm._e()]);
  })], 2) : _vm._e()]), _c(VSpacer)], 1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openEditModal();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-pen mr-2",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Edit ")], 1)], 1)]), _vm.canManageRegions && _vm.editModalShown ? _c("RegionFormModal", {
    ref: "regionForm",
    attrs: {
      id: _vm.region.id,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      entityUpdated: function entityUpdated($event) {
        _vm.editModalHasDoneUpdate = true;
      },
      closed: function closed($event) {
        _vm.editModalHasDoneUpdate ? _vm.refreshPage() : null;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };